import routes from '@/modules/payment-registry/payment-registry-routes';
import store from '@/modules/payment-registry/payment-registry-store';

export default {
    routes,
    store,
}
